var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6,13.76l1.412,1.412L21.48,6.706,22.894,8.12,13.014,18,6.65,11.636l1.414-1.414,2.125,2.125L11.6,13.759Zm0-2.828,4.952-4.953,1.41,1.41-4.952,4.953ZM8.777,16.587,7.364,18,1,11.636l1.414-1.414,1.413,1.413h0l4.951,4.951Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecks);
export default __webpack_public_path__ + "static/media/checks.b0183ce51738109c6e45dd2b18fcfd94.svg";
export { ForwardRef as ReactComponent };